interface InterceptorConfig {
  token: boolean, notTokenTo?: string, tokenTo?: string
}
const config: Record<string, InterceptorConfig> = {
  default: { token: true, notTokenTo: '/login' },
  '/login': { token: false, tokenTo: '/middleware' },
  '/error/*': { token: false },
}
export default config
